<template>
  <div>
    <VAutocomplete
      :label="$t('workOrders.types.choose')"
      :items="displayWorkOrderTypes"
      :multiple="true"
      :loading="loading"
      :value="value"
      data-cy="analysis-workOrderTypes-select"
      @input="updateData"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';

export default {
    components: {
        VAutocomplete,
    },
    props: {
        analysisConfigurationId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            workOrderTypes: [],
            configurations: [],
            value: [],
        };
    },
    computed: {
        ...mapGetters([
            'userLang', 'teamMainLang',
        ]),
        displayWorkOrderTypes() {
            return this.workOrderTypes.map(type => ({
                name: type.name[this.userLang] || type.name[this.teamMainLang],
                id: type.id,
                key: type.key,
            }));
        },
    },
    async created() {
        this.loading = true;
        await this.getWorkOrderTypes();
        const { data } = await this.$rq.getComponentConfiguration(this.analysisConfigurationId);
        this.value = data.workOrderTypes;
        this.loading = false;
    },
    methods: {
        async getWorkOrderTypes() {
            const { data } = await this.$rq.getWorkOrderTypes();
            this.workOrderTypes = data;
        },
        updateData(select) {
            if (select) {
                this.$emit('sendData', {
                    selectedWorkOrdertypes: select,
                });
            }
        },
    },
};
</script>
